import request from '@/utils/request'


// 查询资讯管理列表
export function listArticles(query) {
  return request({
    url: '/zb/articles/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}
export function selectZixunList() {
  return request({
    url: '/zb/articles/selectZixunList',
    method: 'get'
  })
}
// 查询资讯管理分页
export function pageArticles(query) {
  return request({
    url: '/zb/articles/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询资讯管理详细
export function getArticles(data) {
  return request({
    url: '/zb/articles/detail',
    method: 'get',
    params: data
  })
}

// 新增资讯管理
export function addArticles(data) {
  return request({
    url: '/zb/articles/add',
    method: 'post',
    data: data
  })
}

// 修改资讯管理
export function updateArticles(data) {
  return request({
    url: '/zb/articles/edit',
    method: 'post',
    data: data
  })
}

// 删除资讯管理
export function delArticles(data) {
  return request({
    url: '/zb/articles/delete',
    method: 'post',
    data: data
  })
}
